import { useCallback, useRef } from 'react';
import { useBacklogSelector } from '../../../../state/index.tsx';
import { backlogHasPriority, getCards } from '../../../../state/selectors/cards/index.tsx';
import type { CardPriority } from '../../../../model/types.tsx';

export const useImagePrefetch = () => {
	const cards = useBacklogSelector(getCards);
	const shouldRenderPriorityColumn = useBacklogSelector(backlogHasPriority);

	const prefetchedCardIds = useRef(new Set<string>());
	const prefetchedImages = useRef(new Set<string>());

	const prefetchImage = useCallback((src: string) => {
		if (!prefetchedImages.current.has(src)) {
			prefetchedImages.current.add(src);
			new Image().src = src;
		}
	}, []);

	const prefetchPriorityImage = useCallback(
		(priority: CardPriority | null) => {
			if (shouldRenderPriorityColumn && priority) {
				prefetchImage(priority.iconUrl);
			}
		},
		[shouldRenderPriorityColumn, prefetchImage],
	);

	const prefetchImages = useCallback(
		(cardIds: string[]) => {
			const uniqueCards = cardIds.filter((cardId) => !prefetchedCardIds.current.has(cardId));

			uniqueCards.forEach((cardId) => {
				const card = cards[cardId];
				if (!card) {
					return;
				}
				prefetchPriorityImage(card.priority);
				prefetchedCardIds.current.add(cardId);
			});
		},
		[cards, prefetchPriorityImage],
	);

	return prefetchImages;
};
